import { render, staticRenderFns } from "./DialogWorkCoordination.vue?vue&type=template&id=07f7f272&scoped=true"
import script from "./DialogWorkCoordination.vue?vue&type=script&lang=js"
export * from "./DialogWorkCoordination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f7f272",
  null
  
)

export default component.exports